import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Form, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import request from '../../../../../../../../utils/request';
import Modal from '../../../../../../../CustomizedAntDesign/Modal/Modal';
import Input from '../../../../../../../CustomizedAntDesign/Input/Input';
import Button from '../../../../../../../CustomizedAntDesign/Button';

const CrystalPOSModalLoader = () => {
  return (
    <div className="cb-integrations-modal__loader">
      <LoadingOutlined />
      <span>Connecting...</span>
    </div>
  );
};

const CrystalPOSModal = ({ visible, setVisible, setPosType }) => {
  const [loading, setLoading] = useState(false);
  const [requestError, setRequestError] = useState(false);

  const [form] = Form.useForm();

  const apiKey = Form.useWatch('api_key', form);
  const apiSecret = Form.useWatch('api_secret', form);

  const apiKeyPlaceholder = useMemo(() => (requestError ? 'Invalid API Key' : 'API Key'), [requestError]);
  const apiSecretPlaceholder = useMemo(() => (requestError ? 'Invalid API Secret' : 'API Secret'), [requestError]);

  const history = useHistory();

  const handleInstall = async () => {
    setRequestError(false);
    setLoading(true);

    try {
      await request.post('/integrations/crystal-pos', {
        api_key: apiKey,
        api_secret: apiSecret,
      });

      setPosType('CRYSTAL');

      message.success('Crystal POS installed successfully');
      history.push('/help/integrations/crystal-pos/settings');

      setVisible(false);
    } catch (error) {
      message.error('Error installing Crystal POS');

      form.setFieldsValue({
        api_key: '',
        api_secret: '',
      });

      setRequestError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={visible} footer={null} closable={false} width={348} destroyOnClose className="cb-integrations-modal">
      {loading && <CrystalPOSModalLoader />}

      <h2 className="cb-integrations-modal__title">Crystal POS API Credentials</h2>

      <h3 className="cb-integrations-modal__subtitle">
        Please enter the API key
        <br /> and secret
      </h3>

      <Form form={form} autoComplete="off" className={requestError ? 'cb-integrations-modal__input-error' : ''}>
        <Form.Item name="api_key">
          <Input prefix={<FontAwesomeIcon icon="far fa-key" />} placeholder={apiKeyPlaceholder} />
        </Form.Item>

        <Form.Item name="api_secret" className={requestError ? 'cb-integrations-modal__input-error' : ''}>
          <Input type="password" prefix={<FontAwesomeIcon icon="far fa-lock" />} placeholder={apiSecretPlaceholder} />
        </Form.Item>

        <span className="cb-integrations-modal__error">{requestError && 'Check your information and try again'}</span>

        <Form.Item className="cb-integrations-details__form-footer">
          <Button disabled={loading} onClick={() => setVisible(false)} block>
            Cancel
          </Button>

          <Button type="primary" disabled={loading || !apiKey || !apiSecret} onClick={handleInstall} block>
            Continue
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  setPosType(val) {
    dispatch({
      type: 'SET_POS_TYPE',
      payload: val,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CrystalPOSModal);
